module.exports = __webpack_public_path__ + "static/media/spada-trader-banner-3.41ad2591.jpg";